import { render, staticRenderFns } from "./HMcosmetics.vue?vue&type=template&id=3c3c2dbe&scoped=true&"
import script from "./HMcosmetics.vue?vue&type=script&lang=js&"
export * from "./HMcosmetics.vue?vue&type=script&lang=js&"
import style0 from "./HMcosmetics.vue?vue&type=style&index=0&id=3c3c2dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3c2dbe",
  null
  
)

export default component.exports